import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public is_loading = false;
  public configuration: any = {}
  public type;
  public today: any = new Date().getFullYear() + "-" + ("0" + (new Date().getMonth() + 1)).slice(-2) + "-" + ("0" + new Date().getDate()).slice(-2);
  public date = this.today;
  public summary_game: any = [];
  public summary_bank: any = [];
  public summary_seemless: any = [];
  public val = null;
  public profile_uuid: any;
  constructor(private http: HttpService) {
    this.http.getSelectedCompany().subscribe((v) => {
      this.profile_uuid = v;
      this.init();
      this.getConfiguration();
    });
  }

  ngOnInit(): void {
    // this.init()
  }

  inputchange() {
    const val = this.date;
    this.init();
  }

  async init() {
    this.is_loading = true;
    this.summary_game = [];
    this.summary_bank = [];
    const summary = await this.http.post("/admin/company/dashboard/summary-v2", { date: this.date });
    this.summary_bank = summary['bank'];
    this.summary_game = summary['game'];
    this.summary_seemless = summary['seemless'];
    console.log(summary, this.summary_seemless);
    this.is_loading = false;
  }

  summary(variable, column) {
    const va = this[variable];
    return va.reduce((total, obj) => (parseFloat(obj[column]) || 0) + (parseFloat(total) || 0), 0)
  }

  public async getConfiguration() {
    let rtn: any = await this.http.post("/admin/company/setting");
    this.configuration = rtn.setting;
  }
}
